import { marked } from 'marked'


export function MarkdownRenderer(arg) {
    const markdownText = arg;
    const renderedMarkdown = marked(markdownText);

     return <div className="flex flex-row" dangerouslySetInnerHTML={{ __html: renderedMarkdown }} />;
}